angular.module("activityHistory.components", ['app.services']).component("activityHistory", {
    templateUrl: "ng/components/monitorPratica/activityHistory/activityHistory.view.html",
    bindings: {
        model: "=",
        snapshots: "<",
        loading: "<",
        exportIndex: '&'
    },
    controllerAs: "activityHistoryCtrl",
    controller: function ActivityHistory($modalService, $rootScope) {
        var self = this;

        self.$onInit = function () {
            self.model = self.model;
        };

        self.openViewSnapshotModal = function (index) {

           /*  self.currentIndex = self.snapshots[index].dynamicInputPojo.passiveViewIndex;
            self.currentModel = self.snapshots[index].dynamicInputPojo;
            self.portalRunnedPractice= self.model[index].appChannel;

            self.enabled = true;
             */
            self.exportIndex({index: index});
        }

        self.disableModalFromDOM = function () {
            self.enabled = false;
            $modalService.closeModal("snapshotModal");
        }

        self.getWizardMap = function (viewIndex) {
            
            if($rootScope.wizardMap.find(function(element){return element.index == viewIndex})){
                return $rootScope.wizardMap.find(function (element) {
                    return element.index == viewIndex;
              }).viewName;
            }      
        }
    }
});